import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Job } from '@model/entities/job';
import { UserService } from '@service/user/user.service';
import { JobService } from '@service/job.service';
import { ToastService } from '@service/toast/toast.service';
import { TransitionHookService } from '@service/transition-hook.service';
import { ScrollService } from '@service/scroll.service';
import { MobileService } from '@service/mobile.service';
import { EntityCreateComponent } from '@component/entity-create-component';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { LoadingService } from '@service/loading.service';
import { HelperService } from '@service/helper.service';
import { ImageKeys } from '@type/image-keys';
import { StateService } from '@service/state.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-job-create',
  templateUrl: './job-create.component.html',
  styleUrls: ['./job-create.component.scss'],
})
export class JobCreateComponent extends EntityCreateComponent implements OnInit {
  protected entityTypeIdentifier: EntityTypeIdentifier = 'job';

  public mostViewed: Job[] = [];

  // draft
  public draft: Job;

  constructor(
    public userService: UserService,
    private jobService: JobService,
    protected toastService: ToastService,
    protected LoadingService: LoadingService,
    protected transitionHookService: TransitionHookService,
    protected dialog: MatDialog,
    protected scrollService: ScrollService,
    public Mobileservice: MobileService,
    public entityTypeConfigService: EntityTypeConfigService,
    public UserService: UserService,
    protected HelperService: HelperService,
    public StateService: StateService,
    public ActivatedRoute: ActivatedRoute,
    public Router: Router,
  ) {
    super(
      entityTypeConfigService,
      scrollService,
      userService,
      LoadingService,
      HelperService,
      transitionHookService,
      dialog,
      toastService,
      StateService,
      ActivatedRoute,
      Router,
    );
  }

  public ngOnInit() {
    super.ngOnInit();

    this.jobService.getMostViewed().then((mostViewed) => {
      this.mostViewed = mostViewed;
    });
  }

  public deleteImage(imageId: number, key: ImageKeys): Promise<void> {
    return new Promise((resolve, reject) => {
      this.LoadingService.startLoad();

      this.jobService
        .deleteImage(this.draft.id, imageId)
        .then((draft: Job) => {
          this.draft = draft;
          this.initFormGroup();

          this.LoadingService.stopLoad();
          resolve();
        })
        .catch((err) => {
          this.LoadingService.stopLoad();
          reject(err);
        });
    });
  }

  /*
   *   @implement
   */
  protected calcStateVars() {}

  /*
   *   @override
   *
   *   This method is executed every time the form group gets initiated and its an edit
   */
  public customEditActions() {
    this.form.get('profile_type').disable();
  }
}
